import {
  TextField,
  Box,
  Typography,
  FormControl,
  FormLabel,
  Button,
  IconButton,
  FormControlLabel,
  Tooltip,
  Checkbox,
  LinearProgress,
  MenuItem,
  InputLabel,
  Select,
  Avatar,
  Stack,
  useTheme,
  Breadcrumbs, Paper
} from "@mui/material";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import useMediaQuery from "@mui/material/useMediaQuery";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import ResetTvIcon from "@mui/icons-material/ResetTv";
import { Field, Formik } from "formik";
import { CheckBox } from "@mui/icons-material";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { gradeSchema } from "../../Security/validation";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-hot-toast";
import { DataGrid,  GridToolbarContainer,
  GridToolbarQuickFilter, } from "@mui/x-data-grid";
import {
  dataGridHeaderFooterHeight,
  dataGridRowHeight,
  
} from "../../../ui-components/global/utils"
import {
  CheckinAutocomplete,
} from "../../../ui-components/global/Autocomplete";

import {
  fetchApidata,
  getFetchData,
  postApidata,
  postData,
} from "../../../store/reducers/Formapireducer";
import Autocomplete from "@mui/lab/Autocomplete";
import React, { useState, useEffect, useRef } from "react";
import { LoadingButton } from "@mui/lab";
import Swal from "sweetalert2";
import { useProSidebar } from "react-pro-sidebar";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import { formGap } from "../../../ui-components/global/utils";
import store from "../../..";
import { tokens } from "../../../Theme";
// import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
// import ErrorMsgData from "../../Security/validationMsg.json"
import * as Yup from "yup";
import { fetchExplorelitview } from "../../../store/reducers/Explorelitviewapireducer";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";

// import CryptoJS from "crypto-js";
  const EditActivities = () => {
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const navigate = useNavigate();
  let params = useParams();
  const dispatch = useDispatch();
  var recID = params.id;
  var mode = params.Mode;
  var accessID = params.accessID;
  var compID = sessionStorage.getItem("companyId");
  const data = useSelector((state) => state.formApi.Data) || {};
  const Status = useSelector((state) => state.formApi.Status);
  const Msg = useSelector((state) => state.formApi.msg);
  const isLoading = useSelector((state) => state.formApi.postLoading);
  const getLoading = useSelector((state) => state.formApi.getLoading);
  const YearFlag = sessionStorage.getItem("YearFlag");
  const CompanyAutoCode = sessionStorage.getItem("CompanyAutoCode");
  const [funMode, setFunMode] = useState("A");

  const listViewurl = useSelector((state) => state.globalurl.listViewurl);
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const TaskSource = data.TaskSource;
  const commentsRef = useRef(null);
  const [loading, setLoading] = useState(false);
   

  const [pageSize, setPageSize] = React.useState(10);
  const exploreLoading = useSelector((state) => state.exploreApi.loading);
  const [rowCount, setRowCount] = useState(0);
  console.log(CompanyAutoCode, "CompanyAutoCode");
  const Year = sessionStorage.getItem("year");
  const Finyear = sessionStorage.getItem("YearRecorid");
  const CompanyID = sessionStorage.getItem("companyId");
  const { toggleSidebar, broken, rtl } = useProSidebar();
  const location = useLocation();
  const state = location.state || {}; 
  var OPRecid = params.filtertype;
  const ProjectID = state.projectID;
  const ActivitiesID = state.ActivitiesID;
console.log(state, "Activity screen");
  const [errorMsgData, setErrorMsgData] = useState(null);
  const [validationSchema, setValidationSchema] = useState(null);
  const [validationSchema1, setValidationSchema1] = useState(null);
  const [validationSchema2, setValidationSchema2] = useState(null);
  const [validationSchema3, setValidationSchema3] = useState(null);
  const [validationSchema4, setValidationSchema4] = useState(null);
  const [validationSchema5, setValidationSchema5] = useState(null);

  const [show, setScreen] = React.useState("0");
  const [screenChange, setScreenChange] = React.useState("0");

  var userimg = store.getState().globalurl.imageUrl;

  useEffect(() => {
    fetch(process.env.PUBLIC_URL + "/validationcms.json")
      .then((res) => {
        if (!res.ok) throw new Error("Failed to fetch validationcms.json");
        return res.json();
      })
      .then((data) => {
        setErrorMsgData(data);

        let schemaFields = {
          name: Yup.string().trim().required(data.Milestone.name),
        };

        if (CompanyAutoCode === "N") {
          schemaFields.code = Yup.string().required(data.Milestone.code);
        }

        const schema = Yup.object().shape(schemaFields);
        setValidationSchema(schema);
      })
      .catch((err) => console.error("Error loading validationcms.json:", err));
  }, [CompanyAutoCode]);
  useEffect(() => {
    dispatch(getFetchData({ accessID, get: "get", recID }));
  }, [location.key]);
  // *************** INITIALVALUE  *************** //

  const InitialValue = {
    code: data.Code,
    name: data.Name,
    sortorder: data.SortOrder,
    disable: data.Disable === "Y" ? true : false,
  };

  const Fnsave = async (values, del) => {
    // let action = mode === "A" ? "insert" : "update";
    let action =
      mode == "A" && !del
        ? "insert"
        : mode == "E" && del
          ? "harddelete"
          : "update";
    var isCheck = "N";
    if (values.disable == true) {
      isCheck = "Y";
    }

    const idata = {
      RecordID: recID,
      Code: values.code,
      Name: values.name,
      SortOrder: values.sortorder || 0,
      Disable: isCheck,
      OperationStageID: OPRecid,
      CompanyID,
    };

    const response = await dispatch(postData({ accessID, action, idata }));
    if (response.payload.Status == "Y") {
      toast.success(response.payload.Msg);
      // navigate(`/Apps/Secondarylistview/TR234/Activities/${OPRecid}`);
      navigate(-1);
    } else {
      toast.error(response.payload.Msg);
    }
  };


  const fnLogOut = (props) => {
    //   if(Object.keys(ref.current.touched).length === 0){
    //     if(props === 'Logout'){
    //       navigate("/")}
    //       if(props === 'Close'){
    //         navigate("/Apps/TR022/Bank Master")
    //       }

    //       return
    //  }
    Swal.fire({
      title: errorMsgData.Warningmsg[props],
      // text:data.payload.Msg,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: props,
    }).then((result) => {
      if (result.isConfirmed) {
        if (props === "Logout") {
          navigate("/");
        }
        if (props === "Close") {
          navigate(`/Apps/Secondarylistview/TR234/Activities/${OPRecid}`);
        }
      } else {
        return;
      }
    });
  };

    // Activities form and table
    const handleScreenChange = (e) => {
      setScreen(e.target.value);
       if (e.target.value == "0") {
            console.log(accessID, "accessID");
            dispatch(getFetchData({ accessID, get: "get", recID }));
      
            // dispatch(getFetchData({ "get", recID}));
       }
       if (e.target.value == "1") {
            dispatch(
              fetchExplorelitview(
                "TR327",
                "Material",
                `CompanyID='${compID}' AND ActivitiesID='${recID}' AND Type='Material'`,
                ""
              )
            );
           selectCellRowData({ rowData: {}, mode: "A", field: "", type: "material" });
       }
       if (e.target.value == "2") {
             dispatch(
               fetchExplorelitview(
                 "TR327",
                 "Product",
                 `CompanyID='${compID}' AND ActivitiesID='${recID}' AND Type='Product'`,
                 ""
               )
             );
             selectCellRowData({ rowData: {}, mode: "A", field: "", type: "product" });
        }
        if (e.target.value == "3") {
             dispatch(
               fetchExplorelitview(
                 "TR327",
                 "Product",
                 `CompanyID='${compID}' AND ActivitiesID='${recID}' AND Type='Machinery'`,
                 ""
               )
             );
             selectCellRowData({ rowData: {}, mode: "A", field: "", type: "machinery" });
        }
        if (e.target.value == "4") {
             dispatch(
               fetchExplorelitview(
                 "TR327",
                 "Services",
                 `CompanyID='${compID}' AND ActivitiesID='${recID}' AND Type='Services'`,
                 ""
               )
             );
             selectCellRowData({ rowData: {}, mode: "A", field: "", type: "services" });
        }
    };


   const [materialdata, setMaterialdata] = useState({
        recordID: "",
        materialItems: "",
        materialItemID: "",
        materialUnit:"",
        materialRate: "",
        materialQty: "",
        materialActualQty:"",
        materialAmount: "",
        materialComments: "",
      });


   
      const [laomode, setLaoMode] = useState("A");
    

     const selectCellRowData = ({ rowData, mode, field ,setFieldValue }) => {
          setFunMode(mode);
          setLaoMode(mode);
            if(mode == "A"){
              setMaterialdata({
                recordID: "",
                materialItems : "",
                materialUnit:"",
                materialRate: "",
                materialQty: "",
                materialActualQty: null,
                materialAmount: "",
                materialComments: "",
                materialDescription: "",
              });
              setProductdata({
                recordID: "",
                productItems: "",
                productUnit:"",
                productRate: "",
                productQty: "",
                productActualQty: "",
                productAmount: "",
                productComments: "",
                productDescription: "",
              });
              setMachinerydata({
                recordID: "",
                machineryItems: "",
                machineryUnit:"",
                machineryRate: "",
                machineryQty: "",
                machineryActualQty: "",
                machineryAmount: "",
                machineryComments: "",
                machineryDescription: "",
              });
              setServicedata({
                recordID: "",
                serviceItems: "",
                serviceUnit:"",
                serviceRate: "",
                serviceQty: "",
                serviceActualQty: "",
                serviceAmount: "",
                serviceComments: "",
                serviceDescription: "",
              });
            }
         else{
         if (field == "action") {
              setMaterialdata({
                  recordID: rowData.RecordID, 
                  materialUnit: rowData.Uom,  
                  materialRate: rowData.Rate,
                  materialQty: rowData.PlanQty,
                  materialActualQty: rowData.ActualQty,
                  materialAmount: rowData.Amount,
                  materialComments: rowData.Comments,
                  materialDescription: rowData.ItemDescription,
                  materialItems: rowData.ItemID
                    ? {
                        ItemID: rowData.ItemID,   
                        Code: rowData.ItemCode || "",
                        Name: rowData.ItemDescription || "",
                      }
                    : null,
                });
              setFieldValue("materialItems", {
                 ItemID: rowData.ItemID,       
                 Code: rowData.ItemCode || "",
                 Name: rowData.ItemDescription || "",
               });

              setFieldValue("materialActualQty",  rowData.ActualQty ?? 0);
              setFieldValue("materialComments", rowData.Comments || "");
            

              setProductdata({
                recordID: rowData.RecordID,
                productUnit: rowData.Uom,
                productRate: rowData.Rate,
                productQty: rowData.PlanQty,
                productActualQty: rowData.ActualQty,
                productAmount: rowData.Amount,
                productComments: rowData.Comments,
                productDescription: rowData.ItemDescription,
                productItems: rowData.ItemID
                  ? {
                      ItemID: rowData.ItemID,
                      Code: rowData.ItemCode || "",
                      Name: rowData.ItemDescription || "",
                    }
                  : null,
              });
              setFieldValue("productItems", {
                ItemID: rowData.ItemID,        
                Code: rowData.ItemCode || "",
                Name: rowData.ItemDescription || "",
              });
              
              setFieldValue("productActualQty", rowData.ActualQty || 0);
              setFieldValue("productComments", rowData.Comments || "");

            //For Machinery
             setMachinerydata({
              recordID: rowData.RecordID,
              machineryUnit: rowData.Uom,
              machineryRate: rowData.Rate,
              machineryQty: rowData.PlanQty,
              machineryActualQty: rowData.ActualQty,
              machineryAmount: rowData.Amount,
              machineryComments: rowData.Comments,
              machineryDescription: rowData.ItemDescription,
              machineryItems: rowData.ItemID
                ? {
                    ItemID: rowData.ItemID,
                    Code: rowData.ItemCode || "",
                    Name: rowData.ItemDescription || "",
                  }
                : null,
            });
            setFieldValue("machineryItems", {
                ItemID: rowData.ItemID,        
                Code: rowData.ItemCode || "",
                Name: rowData.ItemDescription || "",
             });

            setFieldValue("machineryActualQty", rowData.ActualQty || 0);
            setFieldValue("machineryComments", rowData.Comments ?? "");

            //For Services
             setServicedata({
              recordID: rowData.RecordID,
              serviceUnit: rowData.Uom,
              serviceRate: rowData.Rate,
              serviceQty: rowData.PlanQty,
              serviceActualQty: rowData.ActualQty,
              serviceAmount: rowData.Amount,
              serviceComments: rowData.Comments,
              serviceDescription: rowData.ItemDescription,
              serviceItems: rowData.ItemID
                ? {
                    ItemID: rowData.ItemID,
                    Code: rowData.ItemCode || "",
                    Name: rowData.ItemDescription || "",
                  }
                : null,
            });
            setFieldValue("serviceItems", {
                ItemID: rowData.ItemID,        
                Code: rowData.ItemCode || "",
                Name: rowData.ItemDescription || "",
             });

            setFieldValue("serviceActualQty", rowData.ActualQty || 0);
            setFieldValue("serviceComments", rowData.Comments ?? "");

        }
      }
      console.log(selectCellRowData,"select row datas")

     }
  
     console.log(materialdata.materialItems,"materialItems")
       
     console.log(selectCellRowData,"selectCellRowData");


    const explorelistViewData = useSelector(
        (state) => state.exploreApi.explorerowData
      );
      const explorelistViewcolumn = useSelector(
        (state) => state.exploreApi.explorecolumnData
    );

    console.log(explorelistViewcolumn,"explorelistViewcolumn");

      const VISIBLE_FIELDS = React.useMemo(() => {
        if (show == 1 || show == 2 || show == 3 || show == 4) {
          return [
            "SLNO",
            "action",
            "Item",
            "Uom",
            "Rate",
            "PlanQty",
            "Amount",                   
          ];
        }
        return [];
      }, [show]);


     console.log("SHOW VALUE 👉", show, "TYPE 👉", typeof show);

        const newcolumn = React.useMemo(() => {
        if (!explorelistViewcolumn?.length) return [];
        if (!VISIBLE_FIELDS.length) return [];

        return VISIBLE_FIELDS
          .map(field =>
            explorelistViewcolumn.find(col => col.field === field)
          )
          .filter(Boolean);
      }, [explorelistViewcolumn, VISIBLE_FIELDS]);


      console.log("VISIBLE_FIELDS 👉", VISIBLE_FIELDS);
      console.log("FINAL COLUMNS 👉", newcolumn);

    
    // const explorelistViewData = useSelector(
    //     (state) => state.exploreApi.explorerowData
    //   );
    //   const explorelistViewcolumn = useSelector(
    //     (state) => state.exploreApi.explorecolumnData
    // );

    // console.log(explorelistViewcolumn,"explorelistViewcolumn");

    //  let VISIBLE_FIELDS = []; // <-- default always array

    //   if (show == "1") {
    //     VISIBLE_FIELDS = [
    //       "SLNO",
    //       "ItemDescription",
    //       "Rate",
    //       "PlanQty",
    //       "Amount",
    //       "action",
    //       "Uom"
    //     ];
    //   } else if (show == "2") {
    //     VISIBLE_FIELDS = [
    //       "SLNO",
    //       "ItemDescription",
    //       "Rate",
    //       "PlanQty",
    //       "Amount",
    //       "action",
    //       "Uom"
    //     ];
    //   } else if (show == "3") {
    //     VISIBLE_FIELDS = [
    //       "SLNO",
    //       "ItemDescription",
    //       "Rate",
    //       "PlanQty",
    //       "Amount",
    //       "action",
    //       "Uom"
    //     ];
    //   }

      
    // const newcolumn = React.useMemo(
    //     () =>
    //       explorelistViewcolumn.filter((column) =>
    //         VISIBLE_FIELDS.includes(column.field)
    //       ),
    //     [explorelistViewcolumn]
    // );

     const Materialinitialvalues = {
          description: data.Name,
          date: data.TaskDate,
          materialRate: materialdata.materialRate,
          materialUnit:materialdata.materialUnit,
          // materialItemID: materialdata?.materialItems?.ItemID,
          materialQty: materialdata.materialQty || 1,
          materialActualQty: materialdata.materialActualQty || 0,
          materialAmount: materialdata.materialAmount,
          materialComments: materialdata.materialComments,
          materialItems: materialdata.materialItems || null,        
     };
    
     //For Material
     const MaterialSaveFn = async (values, resetForm, del) =>{
 
        setLoading(true);

          let action =
            funMode === "A" && !del
              ? "insert"
              : funMode === "E" && del
                ? "harddelete"
                : "update";
          //let action = "insert";
         const itemID = values.materialItems?.ItemID;

          
          const rate = values.materialRate;
          const planQty = values.materialQty;
          const amount = values.materialAmount;
          const actualqty = Number(values.materialActualQty || 0);

          const comments = values.materialComments || "";
          //const name = values.materialItems.Name;

          let materialRecid = mode === "A" ? "-1" : materialdata.recordID; 
          
          const materialData = {
            RecordID: materialRecid,
            CompanyID: CompanyID,
            ProjectID: ProjectID,
            ActivitiesID: recID,
            ItemID: itemID,
            Rate:rate,
            ActualQty:actualqty,
            PlanQty: planQty,
            Amount: amount,
            Type: "Material",
            Comments: comments,

          }

          console.log(
          "SAVING ActualQty:",
          values.materialActualQty,
          typeof values.materialActualQty
        );

          const response = await dispatch(
              postData({ accessID: "TR327", action, idata:materialData })
          );
          if (response.payload.Status === "Y") {
            toast.success(response.payload.Msg);
              setLoading(false);
              dispatch(
                fetchExplorelitview(
                  "TR327",
                  "Material",
                  `CompanyID='${compID}' AND ActivitiesID='${recID}' AND Type='Material'`,
                )
              );
             dispatch(getFetchData({ accessID, get: "get", recID }))
             selectCellRowData({
               rowData: {},
               mode: "A",
               field: "",
               type: "material",
             });
       
              resetForm();       
          }else {
                toast.error(response.payload.Msg);
              }
     }


      //For Product
      const [productdata, setProductdata] = useState({
          recordID: "",
          productItems: "",
          productUnit:"",
          productRate: "",
          productQty: 1, 
          productActualQty:"",
          productAmount: "",
          productComments: "",
      });

      const Productinitialvalues = {
          description: data.Name,
          productUnit: productdata.productUnit,
          productRate: productdata.productRate,
          productQty: productdata.productQty || 1,
          productActualQty: productdata.productActualQty || 0,
          productAmount: productdata.productAmount,
          productComments: productdata.productComments,
          productItems: productdata.productItems || null,
      };
 
      const ProductSaveFn = async (values, resetForm, del) => {
          setLoading(true);
        
          let action =
            funMode === "A" && !del
              ? "insert"
              : funMode === "E" && del
              ? "harddelete"
              : "update";
          const idata = {
              RecordID: funMode === "A" ? "-1" : productdata.recordID,
              CompanyID: compID,
              ProjectID: ProjectID,
              ActivitiesID: recID,
              ItemID: values.productItems?.ItemID,
              PlanQty: Number(values.productQty ?? 1),  
              Rate: Number(values.productRate || 0),
              ActualQty: Number(values.productActualQty || 0),
              Amount: Number(values.productAmount || 0),
              Type: "Product",
              Comments: values.productComments || "",
            };

      
          const response = await dispatch(
            postData({ accessID: "TR327", action, idata })
          );
      
          if (response.payload.Status === "Y") {
            toast.success(response.payload.Msg);
         
            setLoading(false);
           
            dispatch(
              fetchExplorelitview(
                "TR327",
                "Product",
                `CompanyID='${compID}' AND ActivitiesID='${recID}' AND Type='Product'`,
              )
            );
            dispatch(getFetchData({ accessID, get: "get", recID }));
            selectCellRowData({ rowData: {}, mode: "A", field: "", type: "product" });
            resetForm();
          } else {
            toast.error(response.payload.Msg);
          }
      };


       useEffect(() => {
          fetch(process.env.PUBLIC_URL + "/validationcms.json")
            .then((res) => {
              if (!res.ok) throw new Error("Failed to fetch validationcms.json");
              return res.json();
            })
            .then((data) => {
              setErrorMsgData(data);
              const schema1 = Yup.object().shape({
                ProName: Yup.object().required(data.Dailytask.ProName).nullable(),
                date: Yup.string().required(data.Dailytask.date),
                TargetDate: Yup.string().required(data.Dailytask.TargetDate),
                TaskType: Yup.string().required(data.Dailytask.TaskType),
                TaskPriority: Yup.string().required(data.Dailytask.TaskPriority),
                estimatedHours: Yup.string().required(data.Dailytask.estimatedHours),
                // actualHours: Yup.string().required(data.Dailytask.actualHours),
                description: Yup.string().required(data.Dailytask.description),
                Comment: Yup.string().required(data.Dailytask.Comment),
              });
      
             const schema2 = Yup.object().shape({
                // materialItems: Yup.object({
                //   ItemID: Yup.string().required("Please Select a Material Item"),
                // })
                //   .nullable()
                //   .typeError("Please Select a Material Item")
                //   .required("Please Select a Material Item"),
                 materialItems: Yup.object().required(data.Activitymaterial.MaterialItem).nullable(),
              });

              const schema3 = Yup.object().shape({
                // productItems: Yup.object({
                //   ItemID: Yup.string().required("Please Select a Product Item"),
                // })  
                //   .nullable()
                //   .typeError("Please Select a Product Item")
                //   .required("Please Select a Product Item"),
                  productItems: Yup.object().required(data.Activitymaterial.ProductItem).nullable(),
  });
            
              const schema4 = Yup.object().shape({
                // machineryItems: Yup.object({
                //   ItemID: Yup.string().required("Please Select a Machinery Item"),
                // })
                //   .nullable()
                //   .typeError("Please Select a Machinery Item")
                //   .required("Please Select a Machinery Item"),
                  machineryItems: Yup.object().required(data.Activitymaterial.MachineryItem).nullable(),    
              });
              const schema5 = Yup.object().shape({
                // machineryItems: Yup.object({
                //   ItemID: Yup.string().required("Please Select a Machinery Item"),
                // })
                //   .nullable()
                //   .typeError("Please Select a Machinery Item")
                //   .required("Please Select a Machinery Item"),
                  serviceItems: Yup.object().required(data.Activitymaterial.ServiceItem).nullable(),    
              });
      
              setValidationSchema1(schema1);
              setValidationSchema2(schema2);
              setValidationSchema3(schema3);
              setValidationSchema4(schema4);
              setValidationSchema5(schema5);
            })
            .catch((err) => console.error("Error loading validationcms.json:", err));
        }, []);

       
      //For Machinery
      const [machinerydata, setMachinerydata] = useState({
          recordID: "",
          machineryItems: "",
          machineryItemID: "",
          machineryUnit:"",
          machineryRate: "",
          machineryQty: "",
          machineryActaulQty:"",
          machineryAmount: "",
          machineryComments: "",
      });


       const Machineryinitialvalues = {
          description: data.Name,
          machineryUnit: machinerydata.machineryUnit,
          machineryRate: machinerydata.machineryRate,
          machineryQty: machinerydata.machineryQty || 1,
          machineryActaulQty: machinerydata.machineryActaulQty || 0,
          machineryAmount: machinerydata.machineryAmount,
          machineryComments: machinerydata.machineryComments,
          machineryItems: machinerydata.machineryItems || null,
      };


      const MachinerySaveFn = async (values, resetForm, del) => {
          setLoading(true);
        
          let action =
            funMode === "A" && !del
              ? "insert"
              : funMode === "E" && del
              ? "harddelete"
              : "update";
          const idata = {
              RecordID: funMode === "A" ? "-1" : productdata.recordID,
              CompanyID: compID,
              ProjectID: ProjectID,
              ActivitiesID: recID,
              ItemID: values.machineryItems?.ItemID,
              PlanQty: Number(values.machineryQty ?? 1),  
              Rate: Number(values.machineryRate || 0),
              ActualQty: Number(values.machineryActualQty || 0),
              Amount: Number(values.machineryAmount || 0),
              Type: "Machinery",
              Comments: values.machineryComments || "",
            };

      
          const response = await dispatch(
            postData({ accessID: "TR327", action, idata })
          );
      
          if (response.payload.Status === "Y") {
            toast.success(response.payload.Msg);
         
            setLoading(false);
           
            dispatch(
              fetchExplorelitview(
                "TR327",
                "Machinery",
                `CompanyID='${compID}' AND ActivitiesID='${recID}' AND Type='Machinery'`,
              )
            );
            dispatch(getFetchData({ accessID, get: "get", recID }));
            selectCellRowData({ rowData: {}, mode: "A", field: "", type: "machinery" });
            resetForm();
          } else {
            toast.error(response.payload.Msg);
          }
      };
      
      //For Service

      const [servicedata, setServicedata] = useState({
          recordID: "",
          serviceItems: "",
          serviceItemID: "",
          serviceUnit:"",
          serviceRate: "",
          serviceQty: "",
          serviceActualQty:"",
          serviceAmount: "",
          serviceComments: "",
      });


      const Serviceinitialvalues = {
            description: data.Name,
            serviceUnit: servicedata.serviceUnit,
            serviceRate: servicedata.serviceRate,

            serviceQty: servicedata.serviceQty || 1,
            serviceActualQty: servicedata.serviceActualQty || 0,
            serviceAmount: servicedata.serviceAmount,
            serviceComments: servicedata.serviceComments,
            serviceItems: servicedata.serviceItems || null,
      };


      const ServiceSaveFn = async (values, resetForm, del) => {
          setLoading(true);
        
          let action =
            funMode === "A" && !del
              ? "insert"
              : funMode === "E" && del
              ? "harddelete"
              : "update";
          const idata = {
              RecordID: funMode === "A" ? "-1" : productdata.recordID,
              CompanyID: compID,
              ProjectID: ProjectID,
              ActivitiesID: recID,
              ItemID: values.serviceItems?.ItemID,
              PlanQty: Number(values.serviceQty ?? 1),  
              Rate: Number(values.serviceRate || 0),
              ActualQty: Number(values.serviceActualQty || 0),
              Amount: Number(values.serviceAmount || 0),
              Type: "Services",
              Comments: values.serviceComments || "",
            };

      
          const response = await dispatch(
            postData({ accessID: "TR327", action, idata })
          );
      
          if (response.payload.Status === "Y") {
            toast.success(response.payload.Msg);
         
            setLoading(false);
           
            dispatch(
              fetchExplorelitview(
                "TR327",
                "Services",
                `CompanyID='${compID}' AND ActivitiesID='${recID}' AND Type='Services'`,
              )
            );
            dispatch(getFetchData({ accessID, get: "get", recID }));
            selectCellRowData({ rowData: {}, mode: "A", field: "", type: "services" });
            resetForm();
          } else {
            toast.error(response.payload.Msg);
          }
      };
      

     function Employee() {
        return (
          <GridToolbarContainer
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
            }}
          >
            <Box sx={{ display: "flex", flexDirection: "row" }}>
              {/* <Typography>
                {show == "2" ? "List of Functions" : "List of Designation"}||{show=="6" && "List of Documents"}
                
              </Typography> */}
              <Typography>
                {show == "1"
                  ? "List of Material "
                  : show == "2"
                  ? "List of Products"
                  : show == "3"
                  ? "List of Machinery"
                  : show == "4"
                  ? "List Of Services"
                  : ""}
              </Typography>
              <Typography variant="h5"> {`(${rowCount})`} </Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              <GridToolbarQuickFilter />
              <Tooltip title="ADD">
                <IconButton type="reset">
                  <AddOutlinedIcon />
                </IconButton>
              </Tooltip>
            </Box>
          </GridToolbarContainer>
        );
     }

     function MaterialReset() {
          return (
            <GridToolbarContainer
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              <Box sx={{ display: "flex", flexDirection: "row" }}>
                {/* <Typography>
                  {show == "2" ? "List of Functions" : "List of Designation"}||{show=="6" && "List of Documents"}
                  
                </Typography> */}
                <Typography>List of Material</Typography>
                <Typography variant="h5">{`(${rowCount})`}</Typography>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <GridToolbarQuickFilter />
                <Tooltip title="ADD">
                  <IconButton type="reset">
                    <AddOutlinedIcon />
                  </IconButton>
                </Tooltip>
              </Box>
            </GridToolbarContainer>
          );
     }

   return (
    <React.Fragment>
      {getLoading ? <LinearProgress /> : false}
     
      <Paper elevation={3} sx={{ margin: "0px 10px", background: "#F2F0F0", height: "50px" }}>

        <Box display="flex" justifyContent="space-between">
          <Box display="flex" borderRadius="3px" alignItems="center">
            {broken && !rtl && (
              <IconButton onClick={() => toggleSidebar()}>
                <MenuOutlinedIcon />
              </IconButton>
            )}
            <Breadcrumbs
              maxItems={2}
              aria-label="breadcrumb"
              separator={<NavigateNextIcon sx={{ color: "#0000D1" }} />}
            >
              <Typography
                variant="h5"
                color="#0000D1"
                sx={{ cursor: "default", marginLeft: "10px" }}
                onClick={() => navigate("/Apps/TR133/Project")}
              >
                {`Project(${state.projectName})`}
              </Typography>

              <Typography
                variant="h5"
                color="#0000D1"
                sx={{ cursor: "default" }}
                onClick={() => navigate(`/Apps/Secondarylistview/TR233/Milestones/${state.projectID}`, { state: { ...state } })}
              >
                {`Milestone(${state.MilestoneName})`}

              </Typography>
              <Typography
                variant="h5"
                color="#0000D1"
                sx={{ cursor: "default" }}
                onClick={() => navigate(`/Apps/Secondarylistview/TR236/Stages/${state.MilestoneID}`, { state: { ...state } })}
              >
                {`Stages(${state.stagesName})`}
              </Typography>
              <Typography
                variant="h5"
                color="#0000D1"
                sx={{ cursor: "default" }}
                onClick={() => navigate(-1)}

              >
                Activity
              </Typography>
            </Breadcrumbs>
          </Box>

          {/* <Box display="flex">
            <Tooltip title="Close">
              <IconButton onClick={() => fnLogOut("Close")} color="error">
                <ResetTvIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title="Logout">
              <IconButton color="error" onClick={() => fnLogOut("Logout")}>
                <LogoutOutlinedIcon />
              </IconButton>
            </Tooltip>
          </Box> */}

          <Box display="flex">
            {mode !== "A" ? (
              <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
                <InputLabel id="demo-select-small">Explore</InputLabel>
                <Select
                  labelId="demo-select-small"
                  id="demo-select-small"
                  value={show}
                  label="Explore"
                  onChange={handleScreenChange}
                >
                  <MenuItem value={0}>Activity</MenuItem>
                  <MenuItem value={1}>Material</MenuItem>
                  <MenuItem value={2}>Product</MenuItem>
                  <MenuItem value={3}>Machinery</MenuItem>
                  <MenuItem value={4}>Services</MenuItem>
                 {/* <MenuItem value={3}>Services</MenuItem> */}
                  {/* <MenuItem value={8}>Change Password</MenuItem> */}
                </Select>
              </FormControl>
            ) : (
              false
            )}
            <Tooltip title="Close">
              <IconButton onClick={() => fnLogOut("Close")} color="error">
                <ResetTvIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title="Logout">
              <IconButton color="error" onClick={() => fnLogOut("Logout")}>
                <LogoutOutlinedIcon />
              </IconButton>
            </Tooltip>
          </Box>

        </Box>
      </Paper>

      {show == "0" && !getLoading ? (
        <Paper elevation={3} sx={{ margin: "10px" }}>
          <Formik
            initialValues={InitialValue}
            onSubmit={(values, setSubmitting) => {
              setTimeout(() => {
                Fnsave(values);
              }, 100);
            }}
            validationSchema={validationSchema}
            enableReinitialize={true}
          >
            {({
              errors,
              touched,
              handleBlur,
              handleChange,
              isSubmitting,
              values,
              handleSubmit,
            }) => (
              <form onSubmit={handleSubmit}>
                {/* {JSON.stringify(errors)} */}
                <Box
                  display="grid"
                  gap={formGap}
                  padding={1}
                  gridTemplateColumns="repeat(2 , minMax(0,1fr))"
                  // gap="30px"
                  sx={{
                    "& > div": {
                      gridColumn: isNonMobile ? undefined : "span 2",
                    },
                  }}
                >
                  {CompanyAutoCode == "Y" ? (
                    <TextField
                      name="code"
                      type="text"
                      id="code"
                      label="Code"
                      placeholder="Auto"
                      variant="standard"
                      focused
                      InputProps={{ readOnly: true }}
                      value={values.code}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      error={!!touched.code && !!errors.code}
                      helperText={touched.code && errors.code}

                    />
                  ) : (
                    <TextField
                      name="code"
                      type="text"
                      id="code"
                      label={
                        <>
                          Code<span style={{ color: "red", fontSize: "20px" }}> * </span>
                        </>
                      }
                      variant="standard"
                      focused
                      // required
                      value={values.code}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      error={!!touched.code && !!errors.code}
                      helperText={touched.code && errors.code}
                      autoFocus
                    />
                  )}

                  <TextField
                    name="name"
                    type="text"
                    id="name"
                    label={
                      <>
                        Description<span style={{ color: "red", fontSize: "20px" }}> * </span>
                      </>
                    }
                    variant="standard"
                    focused
                    value={values.name}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    error={!!touched.name && !!errors.name}
                    helperText={touched.name && errors.name}
                    autoFocus={CompanyAutoCode == "Y"}
                  // required
                  />

                  <TextField
                    name="sortorder"
                    type="number"
                    id="sortorder"
                    label="Sort Order"
                    variant="standard"
                    focused
                    value={values.sortorder}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    error={!!touched.sortorder && !!errors.sortorder}
                    helperText={touched.sortorder && errors.sortorder}
                    sx={{ background: "" }}
                    InputProps={{
                      inputProps: {
                        style: { textAlign: "right" },
                      },
                    }}
                    onWheel={(e) => e.target.blur()}
                    onInput={(e) => {
                      e.target.value = Math.max(0, parseInt(e.target.value))
                        .toString()
                        .slice(0, 8);
                    }}
                  />
                  <Box>
                    <Field
                      //  size="small"
                      type="checkbox"
                      name="disable"
                      id="disable"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      as={Checkbox}
                      label="Disable"
                    />

                    <FormLabel focused={false}>Disable</FormLabel>
                  </Box>

                </Box>
                <Box display="flex" justifyContent="end" padding={1} gap="20px">
                  {/* {YearFlag == "true" ? ( */}
                  <LoadingButton
                    color="secondary"
                    variant="contained"
                    type="submit"
                    loading={isLoading}
                  >
                    Save
                  </LoadingButton>
                  {/* ) : ( */}
                  {/* <Button
                      color="secondary"
                      variant="contained"
                      disabled={true}
                    >
                      Save
                    </Button> */}
                  {/* )} {YearFlag == "true" ? ( */}
                  {mode == "E" ? (
                    <Button
                      color="error"
                      variant="contained"
                      onClick={() => {
                        Swal.fire({
                          title: errorMsgData.Warningmsg.Delete,
                          icon: "warning",
                          showCancelButton: true,
                          confirmButtonColor: "#3085d6",
                          cancelButtonColor: "#d33",
                          confirmButtonText: "Confirm",
                        }).then((result) => {
                          if (result.isConfirmed) {
                            Fnsave(values, "harddelete");
                            // navigate(-1);
                          } else {
                            return;
                          }
                        });
                      }}
                    >
                      Delete
                    </Button>
                  ) : (null)}
                  {/* ) : ( */}
                  {/* <Button
                      color="error"
                      variant="contained"
                      disabled={true}
                    >
                      Delete
                    </Button> */}
                  {/* )} */}
                  <Button
                    color="warning"
                    variant="contained"
                    onClick={() => {
                      //navigate(`/Apps/Secondarylistview/TR234/Activities/${OPRecid}`);
                      navigate(-1);
                    }}
                  >
                    Cancel
                  </Button>
                </Box>

              </form>
            )}
          </Formik>
        </Paper>
      ) : (
        false
      )}
      {show == "1" ? (
        <Paper elevation={3} sx={{ margin: "10px" }}>
           <Formik
                initialValues={{
                  ...Materialinitialvalues,
                  ...InitialValue
                }}
                enableReinitialize={true}
                validationSchema={validationSchema2}
                onSubmit={(values, { resetForm }) => {
                  setTimeout(() => {
                    MaterialSaveFn(values, resetForm, false);
                  }, 100);
                }}
              >
               {({
                  errors,
                  touched,
                  handleBlur,
                  handleChange,
                  isSubmitting,
                  values,
                  handleSubmit,
                  resetForm,
                  setFieldValue,
                  setFieldTouched,
                }) => (
                  <form
                    onSubmit={handleSubmit}
                    onReset={() => {
                      selectCellRowData({
                        rowData: {},
                        mode: "A",
                        field: "",
                        type: "material",
                      });
                      resetForm();
                    }} >
                    <Box
                      display="grid"
                      gap={formGap}
                      padding={1}
                      gridTemplateColumns="repeat(2 , minMax(0,1fr))"
                      // gap="30px"
                      sx={{
                        "& > div": {
                          gridColumn: isNonMobile ? undefined : "span 2",
                        },
                      }}
                    >
                      <FormControl sx={{ gap: formGap }}>
                       <TextField
                          name="Code"
                          type="text"
                          id="code"
                          value={values.code}
                          label="Code"
                          variant="standard"
                          focused
                        />
    
                        <TextField
                          fullWidth
                          variant="standard"
                          type="text"
                          id="description"
                          name="Description"
                           value={values.description}
                          label="Description"
                          focused
                            inputProps={{ readOnly: true }}
                        />
                      </FormControl>
                      
                      <Stack
                        sx={{
                          alignContent: "center",
                          justifyContent: "center",
                          alignItems: "center",
                          position: "relative",
                          right: "0px",
                        }}
                      >
                        <Avatar
                          variant="rounded"
                          src={userimg}
                          sx={{ width: "200px", height: "120px" }}
                        />
                      </Stack>
    
                      <Box
                        m="5px 0 0 0"
                        //height={dataGridHeight}
                        height="50vh"
                        sx={{
                          "& .MuiDataGrid-root": {
                            border: "none",
                          },
                          "& .MuiDataGrid-cell": {
                            borderBottom: "none",
                          },
                          "& .name-column--cell": {
                            color: colors.greenAccent[300],
                          },
                          "& .MuiDataGrid-columnHeaders": {
                            backgroundColor: colors.blueAccent[800],
                            borderBottom: "none",
                          },
                          "& .MuiDataGrid-virtualScroller": {
                            backgroundColor: colors.primary[400],
                          },
                          "& .MuiDataGrid-footerContainer": {
                            borderTop: "none",
                            backgroundColor: colors.blueAccent[800],
                          },
                          "& .MuiCheckbox-root": {
                            color: `${colors.greenAccent[200]} !important`,
                          },
                          "& .odd-row": {
                            backgroundColor: "",
                            color: "", // Color for odd rows
                          },
                          "& .even-row": {
                            backgroundColor: "#D3D3D3",
                            color: "", // Color for even rows
                          },
                        }}
                      >
                       <DataGrid
                          sx={{
                            "& .MuiDataGrid-footerContainer": {
                              height: dataGridHeaderFooterHeight,
                              minHeight: dataGridHeaderFooterHeight,
                            },
                          }}
                            rows={explorelistViewData}
                            columns={newcolumn}
                          // disableSelectionOnClick
                           getRowId={(row) => row.RecordID}
                           rowHeight={dataGridRowHeight}
                           headerHeight={dataGridHeaderFooterHeight}
                            pageSize={pageSize}
                           onPageSizeChange={(newPageSize) =>
                             setPageSize(newPageSize)
                           }
                           onCellClick={(params) => {
                             selectCellRowData({
                               rowData: params.row,
                               mode: "E",
                               field: params.field,
                               setFieldValue,
                                type: "material",
                             });
                           }}
                           rowsPerPageOptions={[5, 10, 20]}
                           pagination
                          // components={{
                          //   Toolbar: ProductReset,
                          // }}
                          //  components={{
                          //    Toolbar: Employee,
                          //  }}

                           components={{
                              Toolbar: () => (
                                <MaterialReset
                                  onAdd={() => {
                                    selectCellRowData({
                                      rowData: {},
                                      mode: "A",
                                      type: "material",
                                      setFieldValue,
                                    });
                                    resetForm();
                                  }}
                                />
                              ),
                            }}
                           onStateChange={(stateParams) =>
                             setRowCount(stateParams.pagination.rowCount)
                           }
                          getRowClassName={(params) =>
                            params.indexRelativeToCurrentPage % 2 === 0
                              ? "odd-row"
                              : "even-row"
                          }
                            loading={exploreLoading}
                          componentsProps={{ 
                            toolbar: {
                              showQuickFilter: true,
                              quickFilterProps: { debounceMs: 500 },
                            },
                          }}
                        /> 
                      </Box>
    
                      <FormControl sx={{ gap: formGap }}>

                         <CheckinAutocomplete
                            name="materialItems"
                              label={
                                <>
                                  Material Item
                                  <span style={{ color: "red", fontSize: "20px" }}> * </span>
                                </>
                               }
                              variant="outlined"
                              id="materialItems"
                              value={values.materialItems}
                              onChange={(newValue) => {
                                 setFieldValue("materialItems", {
                                    ItemID: newValue.RecordID,
                                    Code: newValue.Code,
                                    Name: newValue.Name,
                                  });
                              //   const selectedItem = {
                              //     ItemID: newValue.RecordID, 
                              //     Code: newValue.Code,
                              //     Name: newValue.Name,
                              //  };
                                //setFieldTouched("materialItems", selectedItem);
                               //setFieldValue("materialItems", newValue);

                              setFieldTouched("materialItems", true);

                                // setMaterialdata(prev => ({
                                //     ...prev,
                                //     //materialItems: selectedItem,
                                //     materialItemID: newValue.RecordID, 
                                //     materialName: newValue.Name,
                                //     materialRate: newValue.Price || "",
                                //     materialUnit: newValue.ConsumptionUOM || "",
                                //     materialQty: prev.materialQty || 1,
                                //     materialAmount: (
                                //       Number(newValue.Price || 0) * Number(prev.materialQty || 1)
                                //     ).toFixed(2),
                                //   }));
                                 
                                  setFieldValue("materialUnit", newValue.ConsumptionUOM || "");
                                  setFieldValue("materialRate", newValue.Price || "");

                                  const qty = values.materialQty || 1;
                                  setFieldValue(
                                      "materialAmount",
                                      (Number(newValue.Price) * Number(qty)).toFixed(2)
                                  );

                                  
                                  setTimeout(() => {
                                      commentsRef.current?.focus();
                                  }, 100);
                                  console.log(newValue, "--newvalue items");
                                  console.log(newValue.RecordID, "items RecordID");
                              }}
                              error={!!touched.materialItems && !!errors.materialItems}
                              helperText={
                                  touched.materialItems
                                    ? typeof errors.materialItems === "string"
                                      ? errors.materialItems
                                      : errors.materialItems?.ItemID
                                    : ""
                                }

                              // url={`${listViewurl}?data={"Query":{"AccessID":"TR327","ScreenName":"ActivityInventory","Filter":"CompanyID='${compID}' AND ActivitiesID='1748' AND Type='Material'","Any":""}}`}
                              url={`${listViewurl}?data={"Query":{"AccessID":"2138","ScreenName":"Items","Filter":"CompanyID='${compID}' AND ItemsDesc ='Material'","Any":""}}`}
                          />

                        {/* <Autocomplete
                          options={materials}
                          getOptionLabel={(option) => option.name}
                          onChange={(e, value) => value && handleMaterialSelect(value)}
                          renderInput={(params) => (
                            <TextField {...params} variant="standard" label="Material" focused />
                          )}
                        /> */}

                        <TextField
                          fullWidth
                          variant="standard"
                          type="text"
                          // value={uom}
                          value={values.materialUnit}
                          label="UOM"
                          sx={{
                            backgroundColor: "#ffffff",
                            "& .MuiFilledInput-root": {
                              backgroundColor: "#ffffff",
                            },
                          }}
                          focused
                          InputProps={{ readOnly: true }}
                          inputProps={{ maxLength: 90 }}
                        />

                        <TextField
                          fullWidth
                          variant="standard"
                          type="number"
                          // value={rate}
                          value={values.materialRate}
                          label="Rate"
                          sx={{
                            backgroundColor: "#ffffff",
                            "& .MuiFilledInput-root": {
                              backgroundColor: "#ffffff",
                            },
                          }}
                          onChange={(e) => {
                            const rate = e.target.value || 0;
                            setFieldValue("materialRate", rate);

                            const qty = values.materialQty || 0;
                            setFieldValue(
                              "materialAmount",
                              (qty * rate).toFixed(2)
                            );
                          }}
                          error={!!touched.materialRate && !!errors.materialRate}
                          helperText={touched.materialRate && errors.materialRate}
                          focused
                          // InputProps={{
                          //   readOnly: true,
                          // }}
                           InputProps={{
                             inputProps: {
                                style: {textAlign:'right', maxLength: 90},
                              },
                            }} 
                          //  InputProps={{
                        />

                          <TextField
                          fullWidth
                          variant="standard"
                          type="number"
                          value={values.materialQty}
                          id="materialQty"
                          name="materialQty"
                          label="Quantity"
                         
                          onBlur={handleBlur}
                         
                          onChange={(e) => {
                            const qty = e.target.value;
                            setFieldValue("materialQty", qty);
    
                            const rate = values.materialRate || 0;
                            setFieldValue(
                              "materialAmount",
                              (qty * rate).toFixed(2)
                            );
                          }}
                          error={!!touched.materialQty && !!errors.materialQty}
                          helperText={touched.materialQty && errors.materialQty}
                          sx={{
                            backgroundColor: "#ffffff",
                            "& .MuiFilledInput-root": {
                              backgroundColor: "#ffffff",
                            },
                          }}
                          focused
                           InputProps={{
                             inputProps: {
                                style: {textAlign:'right', maxLength: 90},
                              },
                            }} 
                         
                        />                    
                          
                        {/* <TextField   
                          fullWidth
                          variant="standard"
                          type="number"
                          // value={planQty}
                          value={values.materialQty}
                          onChange={handleQtyChange}
                          label="Plan Qty"
                          
                          onBlur={handleBlur}
                         
                          sx={{
                            backgroundColor: "#ffffff",
                            "& .MuiFilledInput-root": {
                              backgroundColor: "#ffffff",
                            },
                          }}
                          
                          focused
                          onChange={(e) => {
                            const qty = e.target.value;
                            setFieldValue("materialQty", qty);

                            const rate = values.materialRate || 0;
                            setFieldValue(
                              "materialAmount",
                              (qty * rate).toFixed(2)
                            );
                          }}
                          InputProps={{
                             inputProps: {
                                style: { textAlign: "right" , maxLength: 90},
                              },
                          }}
                        /> */}

                        <TextField
                              fullWidth
                              variant="standard"
                              type="number"
                              id="materialActualQty"
                              name="materialActualQty"   
                               label="Actual Qty"
                               value={values.materialActualQty ?? ""}
                              onChange={(e) =>
                                  setFieldValue(
                                    "materialActualQty",
                                    e.target.value === "" ? 0 : Number(e.target.value)
                                  )
                                }
                              sx={{
                                backgroundColor: "#ffffff",
                              }}
                              focused
                              InputProps={{
                                readOnly: true,
                                inputProps: {
                                  style: {textAlign:'right', maxLength: 90},
                                },
                              }}
                          />

    
                        <TextField
                          fullWidth
                          variant="standard"
                          type="number"
                          // value={amount} 
                          value={values.materialAmount}
                          label="Amount"
                          onBlur={handleBlur}
                          sx={{
                            backgroundColor: "#ffffff",
                            "& .MuiFilledInput-root": {
                              backgroundColor: "#ffffff",
                            },
                          }}
                          focused
                           InputProps={{
                             inputProps: {
                                style: {textAlign:'right', maxLength: 90},
                              },
                            }} 
                        />
    
                       <TextField
                          fullWidth
                          variant="standard"
                          type="text"
                          id="materialComments"
                          name="materialComments"
                          value={values.materialComments ?? ""}
                          label="Comments"
                          onChange={(e) =>
                            setFieldValue("materialComments", e.target.value)
                          }
                          sx={{
                            backgroundColor: "#ffffff",
                          }}
                          focused
                          inputProps={{ maxLength: 90 }}
                        />
             
                      </FormControl>

                      </Box>
                      <Box
                        display="flex"
                        justifyContent="end"
                        padding={1}
                        gap={2}
                      >
                        <LoadingButton
                          color="secondary"
                          variant="contained"
                          type="submit"
                          loading={isLoading}
                          disabled={data.TaskSource === "Sprint" && data.Status === "AP"}
                        >
                          Save
                        </LoadingButton>
                        
                        <Button
                          color="error"
                          variant="contained"
                          onClick={() => {
                            Swal.fire({
                              title: errorMsgData.Warningmsg.Delete,
                              icon: "warning",
                              showCancelButton: true,
                              confirmButtonColor: "#3085d6",
                              cancelButtonColor: "#d33",
                              confirmButtonText: "Confirm",
                            }).then((result) => {
                              if (result.isConfirmed) {
                                  MaterialSaveFn(values, resetForm, "harddelete");
                              } else {
                                return;
                              }
                            });
                          }}
                          disabled={funMode === "A" || (data.TaskSource === "Sprint" && data.Status === "AP")}
      
                        >
                          Delete
                        </Button>
                      
                        <Button
                          type="reset"
                          color="warning"
                          variant="contained"
                          onClick={() => {
                            setScreen(0);
                          }}
                        >
                          Cancel
                        </Button>
                      </Box>
                  </form>
                )}
           </Formik>
        </Paper>
      ) : (
        false
      )}
       {show == "2" ? (
        <Paper elevation={3} sx={{ margin: "10px" }}>
           <Formik
                initialValues={{...Productinitialvalues,
                  ...InitialValue
                }}
                enableReinitialize={true}
                validationSchema={validationSchema3}
                onSubmit={(values, { resetForm }) => {
                  setTimeout(() => {
                    ProductSaveFn(values, resetForm, false);
                  }, 100);
                }}
              >
                {({
                  errors,
                  touched,
                  handleBlur,
                  handleChange,
                  isSubmitting,
                  values,
                  handleSubmit,
                  resetForm,
                  setFieldValue,
                  setFieldTouched,
                }) => (
                  <form
                    onSubmit={handleSubmit} 
                     onReset={() => {
                      selectCellRowData({
                        rowData: {},
                        mode: "A",
                        field: "",
                        type: "product",
                      });
                      resetForm();
                    }}>
                    <Box
                      display="grid"
                      gap={formGap}
                      padding={1}
                      gridTemplateColumns="repeat(2 , minMax(0,1fr))"
                      // gap="30px"
                      sx={{
                        "& > div": {
                          gridColumn: isNonMobile ? undefined : "span 2",
                        },
                      }}
                    >
                      <FormControl sx={{ gap: formGap }}>
                       <TextField
                          name="Code"
                          type="text"
                          id="code"
                          value={values.code}
                          label="Code"
                          variant="standard"
                          focused
                        />
    
                        <TextField
                          fullWidth
                          variant="standard"
                          type="text"
                          id="description"
                          name="Description"
                          value={values.description}
                          label="Description"
                          focused
                          //  inputProps={{ readOnly: true }}
                        />
                      </FormControl>
                      
                      <Stack
                        sx={{
                          alignContent: "center",
                          justifyContent: "center",
                          alignItems: "center",
                          position: "relative",
                          right: "0px",
                        }}
                      >
                        <Avatar
                          variant="rounded"
                          src={userimg}
                          sx={{ width: "200px", height: "120px" }}
                        />
                      </Stack>
    
                      <Box
                        m="5px 0 0 0"
                        //height={dataGridHeight}
                        height="50vh"
                        sx={{
                          "& .MuiDataGrid-root": {
                            border: "none",
                          },
                          "& .MuiDataGrid-cell": {
                            borderBottom: "none",
                          },
                          "& .name-column--cell": {
                            color: colors.greenAccent[300],
                          },
                          "& .MuiDataGrid-columnHeaders": {
                            backgroundColor: colors.blueAccent[800],
                            borderBottom: "none",
                          },
                          "& .MuiDataGrid-virtualScroller": {
                            backgroundColor: colors.primary[400],
                          },
                          "& .MuiDataGrid-footerContainer": {
                            borderTop: "none",
                            backgroundColor: colors.blueAccent[800],
                          },
                          "& .MuiCheckbox-root": {
                            color: `${colors.greenAccent[200]} !important`,
                          },
                          "& .odd-row": {
                            backgroundColor: "",
                            color: "", // Color for odd rows
                          },
                          "& .even-row": {
                            backgroundColor: "#D3D3D3",
                            color: "", // Color for even rows
                          },
                        }}
                      >
                       <DataGrid
                          sx={{
                            "& .MuiDataGrid-footerContainer": {
                              height: dataGridHeaderFooterHeight,
                              minHeight: dataGridHeaderFooterHeight,
                            },
                          }}
                            rows={explorelistViewData}
                            columns={newcolumn}
                           //disableSelectionOnClick
                           getRowId={(row) => row.RecordID}
                           rowHeight={dataGridRowHeight}
                           headerHeight={dataGridHeaderFooterHeight}
                           pageSize={pageSize}
                           onPageSizeChange={(newPageSize) =>
                             setPageSize(newPageSize)
                           }
                           onCellClick={(params) => {
                             selectCellRowData({
                               rowData: params.row,
                               mode: "E",
                               field: params.field,
                               setFieldValue,
                               type: "product",
                             });
                           }}
                           rowsPerPageOptions={[5, 10, 20]}
                           pagination
                          // components={{
                          //   Toolbar: ProductReset,
                          // }}
                           components={{
                             Toolbar: Employee,
                           }}
                           onStateChange={(stateParams) =>
                             setRowCount(stateParams.pagination.rowCount)
                           }
                          getRowClassName={(params) =>
                            params.indexRelativeToCurrentPage % 2 === 0
                              ? "odd-row"
                              : "even-row"
                          }
                            loading={exploreLoading}
                          componentsProps={{ 
                            toolbar: {
                              showQuickFilter: true,
                              quickFilterProps: { debounceMs: 500 },
                            },
                          }}
                        /> 
                      </Box>
    
                      <FormControl sx={{ gap: formGap }}>

                    <CheckinAutocomplete
                        name="productItems"
                             //label="Item"
                         label={
                              <>
                              Product Item
                               <span style={{ color: "red", fontSize: "20px" }}> * </span>
                             </>
                          }
                           id="productItems"
                           value={values.productItems}
                           onChange={(newValue) => {
                                setFieldValue("productItems", {
                                    ItemID: newValue.RecordID,
                                    Code: newValue.Code,
                                    Name: newValue.Name,
                                });
                                setFieldTouched("productItems", true);
                          
                               
                                                  // Auto-fill from dropdown
                                setFieldValue("productUnit", newValue.ConsumptionUOM || "" );
                                setFieldValue("productRate", newValue.Price || "");
                          
                                  // Recalculate amount
                                const qty = values.productQty || 1;
                                setFieldValue(
                                    "productAmount",
                                    (Number(newValue.Price) * Number(qty)).toFixed(2)
                                );
                          
                                setTimeout(() => {
                                   commentsRef.current?.focus();
                                }, 100);
                              }}
                              error={!!touched.productItems && !!errors.productItems}
                               helperText={
                                  touched.productItems
                                    ? typeof errors.productItems === "string"
                                      ? errors.productItems
                                      : errors.productItems?.ItemID
                                    : ""
                                }
                            url={`${listViewurl}?data={"Query":{"AccessID":"2137","ScreenName":"Items","Filter":"CompanyID='${compID}' AND ItemsDesc ='Product'","Any":""}}`}
                         />                            

                        <TextField
                          fullWidth
                          variant="standard"
                          type="text"
                          value={values.productUnit}
                          label="UOM"
                          sx={{
                            backgroundColor: "#ffffff",
                            "& .MuiFilledInput-root": {
                              backgroundColor: "#ffffff",
                            },
                          }}  
                          focused
                          InputProps={{ readOnly: true }}
                          inputProps={{ maxLength: 90 }}
                        />

                        <TextField
                            fullWidth
                            variant="standard"
                            type="number"
                            value={values.productRate}
                            label="Rate"
                            focused
                            InputProps={{
                              inputProps: {
                                style: { textAlign:'right', maxLength: 90  },
                              },
                            }}
                          
                            onChange={(e) => {
                              const rate = e.target.value || 0;
                              setFieldValue("productRate", rate);

                              const qty = values.productQty || 0;
                              setFieldValue("productAmount", (qty * rate).toFixed(2));
                            }}
                            sx={{
                              backgroundColor: "#ffffff",
                             
                            }}
                          />

                          
                        <TextField
                          fullWidth
                          variant="standard"
                          type="number"
                          id="productQty"
                          name="productQty"
                          label="Plan Qty"
                          value={values.productQty}
                          onBlur={handleBlur}
                          
                          onChange={(e) => {
                            const qty = e.target.value;
                            setFieldValue("productQty", qty);

                            const rate = values.productRate || 0;
                            setFieldValue("productAmount", (qty * rate).toFixed(2));
                          }}
                          
                          sx={{
                            backgroundColor: "#ffffff",
                            "& .MuiFilledInput-root": {
                              backgroundColor: "#ffffff",
                            },
                          }}
                          focused
                          InputProps={{
                              inputProps: {
                                style: { textAlign:'right', maxLength: 90  },
                              },
                            }}
                        />

                        <TextField
                          fullWidth
                          variant="standard"
                          type="number"
                          id="actualQty"
                          name="ActualQty"
                          value={values.productActualQty}
                          label="Actual Qty"
                          sx={{
                            backgroundColor: "#ffffff",
                            "& .MuiFilledInput-root": {
                              backgroundColor: "#ffffff",
                            },
                          }}
                          focused
                          InputProps={{
                            readOnly: true,
                              inputProps: {
                                style: {textAlign:'right', maxLength: 90  },
                              },
                            }}
                        />
    
                        <TextField
                          fullWidth
                          variant="standard"
                          type="number"
                          id="productAmount"
                          value={values.productAmount}
                          name="productAmount"
                          label="Amount"
                          onBlur={handleBlur}
                          sx={{
                            backgroundColor: "#ffffff",
                            "& .MuiFilledInput-root": {
                              backgroundColor: "#ffffff",
                            },
                          }}
                          focused
                          InputProps={{
                              inputProps: {
                                style: {textAlign:'right', maxLength: 90  },
                              },
                            }}
                        />
    
                        <TextField
                          fullWidth
                            variant="standard"
                            type="text"
                            id="productComments"
                            name="productComments"
                            value={values.productComments ?? "" }
                            //  inputRef={commentsRef} // <-- ADD THIS
                            label="Comments"
                              onChange={(e) =>
                              setFieldValue("productComments", e.target.value)
                            }
                            sx={{
                              backgroundColor: "#ffffff", // Set the background to white
                              "& .MuiFilledInput-root": {
                                backgroundColor: "#ffffff", // Ensure the filled variant also has a white background
                              },
                            }}
                            focused
                            autoFocus
                            multiline
                          inputProps={{ maxLength: 90 }}
                        />
                        
                      </FormControl>
                      </Box>
                      <Box
                        display="flex"
                        justifyContent="end"
                        padding={1}
                        gap={2}
                      >
                        <LoadingButton
                          color="secondary"
                          variant="contained"
                          type="submit"
                          loading={isLoading}
                          disabled={data.TaskSource === "Sprint" && data.Status === "AP"}
                        >
                          Save
                        </LoadingButton>
                        
                        <Button
                          color="error"
                          variant="contained"
                          onClick={() => {
                            Swal.fire({
                              title: errorMsgData.Warningmsg.Delete,
                              icon: "warning",
                              showCancelButton: true,
                              confirmButtonColor: "#3085d6",
                              cancelButtonColor: "#d33",
                              confirmButtonText: "Confirm",
                            }).then((result) => {
                              if (result.isConfirmed) {
                                  ProductSaveFn(values, resetForm, "harddelete");
                              } else {
                                return;
                              }
                            });
                          }}
                          disabled={funMode === "A" || (data.TaskSource === "Sprint" && data.Status === "AP")}
      
                        >
                          Delete
                        </Button>
                      
                        <Button
                          type="reset"
                          color="warning"
                          variant="contained"
                          onClick={() => {
                            setScreen(0);
                          }}
                        >
                          Cancel
                        </Button>
                      </Box>
                  </form>
                )}
           </Formik>
        </Paper>
      ) : (
        false
      )}
       {show == "3" ? (
        <Paper elevation={3} sx={{ margin: "10px" }}>
           <Formik
                initialValues={{...Machineryinitialvalues,
                  ...InitialValue
                }}
                enableReinitialize={true}
                validationSchema={validationSchema4}
                onSubmit={(values, { resetForm }) => {
                  setTimeout(() => {
                    MachinerySaveFn(values, resetForm, false);
                  }, 100);
                }}
              >
                {({
                  errors,
                  touched,
                  handleBlur,
                  handleChange,
                  isSubmitting,
                  values,
                  handleSubmit,
                  resetForm,
                  setFieldValue,
                  setFieldTouched,
                }) => (
                  <form
                    onSubmit={handleSubmit} 
                    onReset={() => {
                      selectCellRowData({
                        rowData: {},
                        mode: "A",
                        field: "",
                        type: "machinery",
                      });
                      resetForm();
                    }} >
                    <Box
                      display="grid"
                      gap={formGap}
                      padding={1}
                      gridTemplateColumns="repeat(2 , minMax(0,1fr))"
                      // gap="30px"
                      sx={{
                        "& > div": {
                          gridColumn: isNonMobile ? undefined : "span 2",
                        },
                      }}
                    >
                      <FormControl sx={{ gap: formGap }}>
                       <TextField
                          name="Code"
                          type="text"
                          id="code"
                          value={values.code}
                          label="Code"
                          variant="standard"
                          focused
                        />
    
                        <TextField
                          fullWidth
                          variant="standard"
                          type="text"
                          id="description"
                          value={values.description}
                          name="Description"
                          //  value={values.description}
                          label="Description"
                          focused
                          //  inputProps={{ readOnly: true }}
                        />
                      </FormControl>
                      
                      <Stack
                        sx={{
                          alignContent: "center",
                          justifyContent: "center",
                          alignItems: "center",
                          position: "relative",
                          right: "0px",
                        }}
                      >
                        <Avatar
                          variant="rounded"
                          src={userimg}
                          sx={{ width: "200px", height: "120px" }}
                        />
                      </Stack>
    
                      <Box
                        m="5px 0 0 0"
                        //height={dataGridHeight}
                        height="50vh"
                        sx={{
                          "& .MuiDataGrid-root": {
                            border: "none",
                          },
                          "& .MuiDataGrid-cell": {
                            borderBottom: "none",
                          },
                          "& .name-column--cell": {
                            color: colors.greenAccent[300],
                          },
                          "& .MuiDataGrid-columnHeaders": {
                            backgroundColor: colors.blueAccent[800],
                            borderBottom: "none",
                          },
                          "& .MuiDataGrid-virtualScroller": {
                            backgroundColor: colors.primary[400],
                          },
                          "& .MuiDataGrid-footerContainer": {
                            borderTop: "none",
                            backgroundColor: colors.blueAccent[800],
                          },
                          "& .MuiCheckbox-root": {
                            color: `${colors.greenAccent[200]} !important`,
                          },
                          "& .odd-row": {
                            backgroundColor: "",
                            color: "", // Color for odd rows
                          },
                          "& .even-row": {
                            backgroundColor: "#D3D3D3",
                            color: "", // Color for even rows
                          },
                        }}
                      >
                       <DataGrid
                          sx={{
                            "& .MuiDataGrid-footerContainer": {
                              height: dataGridHeaderFooterHeight,
                              minHeight: dataGridHeaderFooterHeight,
                            },
                          }}
                            rows={explorelistViewData}
                            columns={newcolumn}
                          // disableSelectionOnClick
                           getRowId={(row) => row.RecordID}
                           rowHeight={dataGridRowHeight}
                           headerHeight={dataGridHeaderFooterHeight}
                            pageSize={pageSize}
                           onPageSizeChange={(newPageSize) =>
                             setPageSize(newPageSize)
                           }
                           onCellClick={(params) => {
                             selectCellRowData({
                               rowData: params.row,
                               mode: "E",
                               field: params.field,
                               setFieldValue,
                               type: "machinery",
                             });
                           }}
                           rowsPerPageOptions={[5, 10, 20]}
                           pagination
                          // components={{
                          //   Toolbar: ProductReset,
                          // }}
                           components={{
                            
                             Toolbar: Employee,
                           }}
                           onStateChange={(stateParams) =>
                             setRowCount(stateParams.pagination.rowCount)
                           }
                          getRowClassName={(params) =>
                            params.indexRelativeToCurrentPage % 2 === 0
                              ? "odd-row"
                              : "even-row"
                          }
                            loading={exploreLoading}
                          componentsProps={{ 
                            toolbar: {
                              showQuickFilter: true,
                              quickFilterProps: { debounceMs: 500 },
                            },
                          }}
                        /> 
                      </Box>
    
                      <FormControl sx={{ gap: formGap }}>

                        {/* <Autocomplete
                          options={materials}
                          getOptionLabel={(option) => option.name}
                          onChange={(e, value) => value && handleMaterialSelect(value)}
                          renderInput={(params) => (
                            <TextField {...params} variant="standard" label="Material" focused />
                          )}
                        />  */}

                    <CheckinAutocomplete
                      name="machineryItems"
                      //label="Item"
                      label={
                        <>
                          Machinery Item
                          <span style={{ color: "red", fontSize: "20px" }}> * </span>
                        </>
                      }
                      id="machineryItems"
                      value={values.machineryItems}
                      onChange={(newValue) => {
                        setFieldValue("machineryItems", {
                          ItemID: newValue.RecordID,
                          Code: newValue.Code,
                          Name: newValue.Name,
                        });
                        setFieldTouched("machineryItems", true);
                      

                        setFieldValue("machineryUnit", newValue.ConsumptionUOM || "" );
                        setFieldValue("machineryRate", newValue.Price || "");

                        // Recalculate amount
                        const qty = values.machineryQty || 1;
                        setFieldValue(
                          "machineryAmount",
                          (Number(newValue.Price) * Number(qty)).toFixed(2)
                        );

                        setTimeout(() => {
                          commentsRef.current?.focus();
                        }, 100);

                        console.log(newValue, "--newvalue machineryItems");
                      }}
                        error={!!touched.machineryItems && !!errors.machineryItems}
                              helperText={
                                  touched.machineryItems
                                    ? typeof errors.machineryItems === "string"
                                      ? errors.machineryItems
                                      : errors.machineryItems?.ItemID
                                    : ""
                                }
                      url={`${listViewurl}?data={"Query":{"AccessID":"2142","ScreenName":"Items","Filter":"CompanyID='76'","Any":""}}`}
                    />                        
                        
                        <TextField
                          fullWidth
                          variant="standard"
                          type="text"
                          id="uom"
                          value={values.machineryUnit}
                          name="uom"
                          label="UOM"
                          sx={{
                            backgroundColor: "#ffffff",
                            "& .MuiFilledInput-root": {
                              backgroundColor: "#ffffff",
                            },
                          }}
                          focused
                          InputProps={{ readOnly: true }}
                          inputProps={{ maxLength: 90 }}
                        />

                        <TextField
                          fullWidth
                          variant="standard"
                          type="number" 
                          id="machineryRate"
                          value={values.machineryRate}
                          name="machineryRate"
                          label="Rate"
                           onChange={(e) => {
                              const rate = e.target.value || 0;
                              setFieldValue("machineryRate", rate);

                              const qty = values.machineryQty || 0;
                              setFieldValue("machineryAmount", (qty * rate).toFixed(2));
                            }}
                          sx={{
                            backgroundColor: "#ffffff",
                            "& .MuiFilledInput-root": {
                              backgroundColor: "#ffffff",
                            },
                          }}
                          focused
                          //  InputProps={{ readOnly: true }}
                          InputProps={{
                            readOnly: true,
                              inputProps: {
                                style: {textAlign:'right', maxLength: 90  },
                              },
                            }}
                          //  InputProps={{
                        />
                          
                        <TextField
                          fullWidth
                          variant="standard"
                          type="number"
                          id="machineryQty"
                          name= "machineryQty"
                          value={values.machineryQty}
                          label="Plan Qty"
                         
                          onBlur={handleBlur}
                          onChange={(e) => {
                            const qty = e.target.value;
                            setFieldValue("machineryQty", qty);

                            const rate = values.machineryRate || 0;
                            setFieldValue("machineryAmount", (qty * rate).toFixed(2));
                          }}
                          sx={{
                            backgroundColor: "#ffffff",
                            "& .MuiFilledInput-root": {
                              backgroundColor: "#ffffff",
                            },
                          }}
                          focused
                          InputProps={{
                              inputProps: {
                                style: { textAlign:'right', maxLength: 90  },
                              },
                            }}
                        />

                          <TextField
                            fullWidth
                            variant="standard"
                            type="number"
                            id="actualQty"
                            name="ActualQty"
                            value={values.machineryActaulQty}
                            label="Actual Qty"
                            sx={{
                              backgroundColor: "#ffffff",
                              "& .MuiFilledInput-root": {
                                backgroundColor: "#ffffff",
                              },
                            }}
                            focused
                            InputProps={{
                              readOnly: true,
                               inputProps: {
                                 style: { textAlign:'right', maxLength: 90  },
                               },
                            }}
                         />
    
                        <TextField
                          fullWidth
                          variant="standard"
                          type="number"
                          id="machineryAmount"
                          name="machineryAmount"
                          value={values.machineryAmount}  
                          label="Amount"
                          
                          sx={{
                            backgroundColor: "#ffffff",
                            "& .MuiFilledInput-root": {
                              backgroundColor: "#ffffff",
                            },
                          }}
                          focused
                          InputProps={{
                              inputProps: {
                                style: {textAlign:'right', },
                              },
                          }}
                        />
    
                        <TextField
                          fullWidth
                            variant="standard"
                            type="text"
                            id="machineryComments"
                            name="machineryComments"
                            label="Comments"
                            value={values.machineryComments ?? ""}
                            onChange={(e) =>
                              setFieldValue("machineryComments", e.target.value)
                            }
                            sx={{
                              backgroundColor: "#ffffff", // Set the background to white
                              "& .MuiFilledInput-root": {
                                backgroundColor: "#ffffff", // Ensure the filled variant also has a white background
                              },
                            }}
                            focused
                            autoFocus
                            multiline
                          inputProps={{ maxLength: 90 }}
                        />
                        
                      </FormControl>
                      </Box>
                      <Box
                        display="flex"
                        justifyContent="end"
                        padding={1}
                        gap={2}
                      >
                        <LoadingButton
                          color="secondary"
                          variant="contained"
                          type="submit"
                          loading={isLoading}
                          disabled={data.TaskSource === "Sprint" && data.Status === "AP"}
                        >
                          Save
                        </LoadingButton>
                        
                        <Button
                          color="error"
                          variant="contained"
                          onClick={() => {
                            Swal.fire({
                              title: errorMsgData.Warningmsg.Delete,
                              icon: "warning",
                              showCancelButton: true,
                              confirmButtonColor: "#3085d6",
                              cancelButtonColor: "#d33",
                              confirmButtonText: "Confirm",
                            }).then((result) => {
                              if (result.isConfirmed) {
                                 MachinerySaveFn(values, resetForm, "harddelete");
                              } else {
                                return;
                              }
                            });
                          }}
                          disabled={funMode === "A" || (data.TaskSource === "Sprint" && data.Status === "AP")}
      
                        >
                          Delete
                        </Button>
                      
                        <Button
                          type="reset"
                          color="warning"
                          variant="contained"
                          onClick={() => {
                            setScreen(0);
                          }}
                        >
                          Cancel
                        </Button>
                      </Box>
                  </form>
                )}
           </Formik>
        </Paper>
      ) : (
        false
      )}
       {show == "4" ? (
        <Paper elevation={3} sx={{ margin: "10px" }}>
           <Formik
                initialValues={{ ...Serviceinitialvalues,
                  ...InitialValue
                }}
                enableReinitialize={true}
                 validationSchema={validationSchema5}
                onSubmit={(values, { resetForm }) => {
                  setTimeout(() => {
                    ServiceSaveFn(values, resetForm, false);
                  }, 100);
                }}
              >
                {({
                  errors,
                  touched,
                  handleBlur,
                  handleChange,
                  isSubmitting,
                  values,
                  handleSubmit,
                  resetForm,
                  setFieldValue,
                  setFieldTouched,
                }) => (
                  <form
                    onSubmit={handleSubmit} 
                    onReset={() => {
                      selectCellRowData({
                        rowData: {},
                        mode: "A",
                        field: "",
                        type: "services",
                      });
                      resetForm();
                    }} >
                    <Box
                      display="grid"
                      gap={formGap}
                      padding={1}
                      gridTemplateColumns="repeat(2 , minMax(0,1fr))"
                      // gap="30px"
                      sx={{
                        "& > div": {
                          gridColumn: isNonMobile ? undefined : "span 2",
                        },
                      }}
                    >
                      <FormControl sx={{ gap: formGap }}>
                       <TextField
                          name="Code"
                          type="text"
                          id="code"
                          value={values.code}
                          label="Code"
                          variant="standard"
                          focused
                        />
    
                        <TextField
                          fullWidth
                          variant="standard"
                          type="text"
                          id="description"
                          value={values.description}
                          name="description"
                          //  value={values.description}
                          label="Description"
                          focused
                          //  inputProps={{ readOnly: true }}
                        />
                      </FormControl>
                      
                      <Stack
                        sx={{
                          alignContent: "center",
                          justifyContent: "center",
                          alignItems: "center",
                          position: "relative",
                          right: "0px",
                        }}
                      >
                        <Avatar
                          variant="rounded"
                          src={userimg}
                          sx={{ width: "200px", height: "120px" }}
                        />
                      </Stack>
    
                      <Box
                        m="5px 0 0 0"
                        //height={dataGridHeight}
                        height="50vh"
                        sx={{
                          "& .MuiDataGrid-root": {
                            border: "none",
                          },
                          "& .MuiDataGrid-cell": {
                            borderBottom: "none",
                          },
                          "& .name-column--cell": {
                            color: colors.greenAccent[300],
                          },
                          "& .MuiDataGrid-columnHeaders": {
                            backgroundColor: colors.blueAccent[800],
                            borderBottom: "none",
                          },
                          "& .MuiDataGrid-virtualScroller": {
                            backgroundColor: colors.primary[400],
                          },
                          "& .MuiDataGrid-footerContainer": {
                            borderTop: "none",
                            backgroundColor: colors.blueAccent[800],
                          },
                          "& .MuiCheckbox-root": {
                            color: `${colors.greenAccent[200]} !important`,
                          },
                          "& .odd-row": {
                            backgroundColor: "",
                            color: "", // Color for odd rows
                          },
                          "& .even-row": {
                            backgroundColor: "#D3D3D3",
                            color: "", // Color for even rows
                          },
                        }}
                      >
                       <DataGrid
                          sx={{
                            "& .MuiDataGrid-footerContainer": {
                              height: dataGridHeaderFooterHeight,
                              minHeight: dataGridHeaderFooterHeight,
                            },
                          }}
                            rows={explorelistViewData}
                            columns={newcolumn}
                          // disableSelectionOnClick
                           getRowId={(row) => row.RecordID}
                           rowHeight={dataGridRowHeight}
                           headerHeight={dataGridHeaderFooterHeight}
                            pageSize={pageSize}
                           onPageSizeChange={(newPageSize) =>
                             setPageSize(newPageSize)
                           }
                           onCellClick={(params) => {
                             selectCellRowData({
                               rowData: params.row,
                               mode: "E",
                               field: params.field,
                               setFieldValue,
                               type: "services",
                             });
                           }}
                           rowsPerPageOptions={[5, 10, 20]}
                           pagination
                          // components={{
                          //   Toolbar: ProductReset,
                          // }}
                           components={{
                            
                             Toolbar: Employee,
                           }}
                           onStateChange={(stateParams) =>
                             setRowCount(stateParams.pagination.rowCount)
                           }
                          getRowClassName={(params) =>
                            params.indexRelativeToCurrentPage % 2 === 0
                              ? "odd-row"
                              : "even-row"
                          }
                            loading={exploreLoading}
                          componentsProps={{ 
                            toolbar: {
                              showQuickFilter: true,
                              quickFilterProps: { debounceMs: 500 },
                            },
                          }}
                        /> 
                      </Box>
    
                      <FormControl sx={{ gap: formGap }}>

                        {/* <Autocomplete
                          options={materials}
                          getOptionLabel={(option) => option.name}
                          onChange={(e, value) => value && handleMaterialSelect(value)}
                          renderInput={(params) => (
                            <TextField {...params} variant="standard" label="Material" focused />
                          )}
                        />  */}

                    <CheckinAutocomplete
                      name="serviceItems"
                      //label="Item"
                      label={
                        <>
                          Services Item
                          <span style={{ color: "red", fontSize: "20px" }}> * </span>
                        </>
                      }
                      id="serviceItems"
                      value={values.serviceItems}
                      onChange={(newValue) => {
                        setFieldValue("serviceItems", {
                          ItemID: newValue.RecordID,
                          Code: newValue.Code,
                          Name: newValue.Name,
                        });
                        setFieldTouched("serviceItems", true);
                      

                        setFieldValue("serviceUnit", newValue.ConsumptionUOM || "" );
                        setFieldValue("serviceRate", newValue.Price || "");

                        // Recalculate amount
                        const qty = values.serviceQty || 1;
                        setFieldValue(
                          "serviceAmount",
                          (Number(newValue.Price) * Number(qty)).toFixed(2)
                        );

                        setTimeout(() => {
                          commentsRef.current?.focus();
                        }, 100);

                        console.log(newValue, "--newvalue serviceItems");
                      }}
                        error={!!touched.serviceItems && !!errors.serviceItems}
                              helperText={
                                  touched.serviceItems
                                    ? typeof errors.serviceItems === "string"
                                      ? errors.serviceItems
                                      : errors.serviceItems?.ItemID
                                    : ""
                                }
                      url={`${listViewurl}?data={"Query":{"AccessID":"2139","ScreenName":"Service","Filter":"CompanyID='76' AND ItemsDesc ='Services'","Any":""}}`}
                    />                        
                        
                        <TextField
                          fullWidth
                          variant="standard"
                          type="text"
                          id="uom"
                          value={values.serviceUnit}
                          name="uom"
                          label="UOM"
                          sx={{
                            backgroundColor: "#ffffff",
                            "& .MuiFilledInput-root": {
                              backgroundColor: "#ffffff",
                            },
                          }}
                          focused
                          InputProps={{ readOnly: true }}
                          inputProps={{ maxLength: 90 }}
                        />

                        <TextField
                          fullWidth
                          variant="standard"
                          type="number" 
                          id="serviceRate"
                          value={values.serviceRate}
                          name="serviceRate"
                          label="Rate"
                           onChange={(e) => {
                              const rate = e.target.value || 0;
                              setFieldValue("serviceRate", rate);

                              const qty = values.serviceQty || 0;
                              setFieldValue("serviceAmount", (qty * rate).toFixed(2));
                            }}
                          sx={{
                            backgroundColor: "#ffffff",
                            "& .MuiFilledInput-root": {
                              backgroundColor: "#ffffff",
                            },
                          }}
                          focused
                          //  InputProps={{ readOnly: true }}
                          InputProps={{
                            readOnly: true,
                              inputProps: {
                                style: {textAlign:'right', maxLength: 90  },
                              },
                            }}
                          //  InputProps={{
                        />
                          
                        <TextField
                          fullWidth
                          variant="standard"
                          type="number"
                          id="serviceQty"
                          name= "serviceQty"
                          value={values.serviceQty}
                          label="Plan Qty"
                         
                          onBlur={handleBlur}
                          onChange={(e) => {
                            const qty = e.target.value;
                            setFieldValue("serviceQty", qty);

                            const rate = values.serviceRate || 0;
                            setFieldValue("serviceAmount", (qty * rate).toFixed(2));
                          }}
                          sx={{
                            backgroundColor: "#ffffff",
                            "& .MuiFilledInput-root": {
                              backgroundColor: "#ffffff",
                            },
                          }}
                          focused
                          InputProps={{
                              inputProps: {
                                style: { textAlign:'right', maxLength: 90  },
                              },
                            }}
                        />

                          <TextField
                            fullWidth
                            variant="standard"
                            type="number"
                            id="actualQty"
                            name="actualQty"
                            value={values.serviceActualQty}
                            label="Actual Qty"
                            sx={{
                              backgroundColor: "#ffffff",
                              "& .MuiFilledInput-root": {
                                backgroundColor: "#ffffff",
                              },
                            }}
                            focused
                            InputProps={{
                              readOnly: true,
                               inputProps: {
                                 style: { textAlign:'right', maxLength: 90  },
                               },
                            }}
                         />
    
                        <TextField
                          fullWidth
                          variant="standard"
                          type="number"
                          id="serviceAmount"
                          name="serviceAmount"
                          value={values.serviceAmount}  
                          label="Amount"
                          
                          sx={{
                            backgroundColor: "#ffffff",
                            "& .MuiFilledInput-root": {
                              backgroundColor: "#ffffff",
                            },
                          }}
                          focused
                          InputProps={{
                              inputProps: {
                                style: {textAlign:'right', },
                              },
                          }}
                        />
    
                        <TextField
                          fullWidth
                            variant="standard"
                            type="text"
                            id="serviceComments"
                            name="serviceComments"
                            label="Comments"
                            value={values.serviceComments ?? ""}
                            onChange={(e) =>
                              setFieldValue("serviceComments", e.target.value)
                            }
                            sx={{
                              backgroundColor: "#ffffff", // Set the background to white
                              "& .MuiFilledInput-root": {
                                backgroundColor: "#ffffff", // Ensure the filled variant also has a white background
                              },
                            }}
                            focused
                            autoFocus
                            multiline
                          inputProps={{ maxLength: 90 }}
                        />
                        
                      </FormControl>
                      </Box>
                      <Box
                        display="flex"
                        justifyContent="end"
                        padding={1}
                        gap={2}
                      >
                        <LoadingButton
                          color="secondary"
                          variant="contained"
                          type="submit"
                          loading={isLoading}
                          disabled={data.TaskSource === "Sprint" && data.Status === "AP"}
                        >
                          Save
                        </LoadingButton>
                        
                        <Button
                          color="error"
                          variant="contained"
                          onClick={() => {
                            Swal.fire({
                              title: errorMsgData.Warningmsg.Delete,
                              icon: "warning",
                              showCancelButton: true,
                              confirmButtonColor: "#3085d6",
                              cancelButtonColor: "#d33",
                              confirmButtonText: "Confirm",
                            }).then((result) => {
                              if (result.isConfirmed) {
                                 ServiceSaveFn(values, resetForm, "harddelete");
                              } else {
                                return;
                              }
                            });
                          }}
                          disabled={funMode === "A" || (data.TaskSource === "Sprint" && data.Status === "AP")}
      
                        >
                          Delete
                        </Button>
                      
                        <Button
                          type="reset"
                          color="warning"
                          variant="contained"
                          onClick={() => {
                            setScreen(0);
                          }}
                        >
                          Cancel
                        </Button>
                      </Box>
                  </form>
                )}
           </Formik>
        </Paper>
      ) : (
        false
      )}
    </React.Fragment>
  );
};

export default EditActivities;








  // <Formik
  //           // initialValues={Productinitialvalues}
  //           enableReinitialize={true}
  //           // validationSchema={validationSchema4}
  //           onSubmit={(values, { resetForm }) => {
  //             setTimeout(() => {
  //               // ProductSaveFn(values, resetForm, false);
  //             }, 100);
  //           }}
  //         >
  //           {({
  //             errors,
  //             touched,
  //             handleBlur,
  //             handleChange,
  //             isSubmitting,
  //             values,
  //             handleSubmit,
  //             resetForm,
  //             setFieldValue,
  //             setFieldTouched,
  //           }) => (
  //             <form
  //               onSubmit={handleSubmit}
  //               onReset={() => {
  //                 // selectCellRowData({
  //                 //   rowData: {},
  //                 //   mode: "A",
  //                 //   field: "",
  //                 //   type: "product",
  //                 // });
  //                 resetForm();
  //               }}
  //             >
  //               <Box
  //                 display="grid"
  //                 gap={formGap}
  //                 padding={1}
  //                 gridTemplateColumns="repeat(2 , minMax(0,1fr))"
  //                 // gap="30px"
  //                 sx={{
  //                   "& > div": {
  //                     gridColumn: isNonMobile ? undefined : "span 2",
  //                   },
  //                 }}
  //               >
  //                 <FormControl sx={{ gap: formGap }}>
                  
  //                   <TextField
  //                     name="date"
  //                     type="date"
  //                     id="date"
  //                     label="Date"
  //                     variant="standard"
  //                     focused
  //                     format="MM-DD-YYYY"
  //                     value={values.date}
  //                     onBlur={handleBlur}
  //                     onChange={handleChange}
  //                     error={!!touched.date && !!errors.date}
  //                     helperText={touched.date && errors.date}
  //                     inputProps={{ readOnly: true }}
  //                   />

  //                   <TextField
  //                     fullWidth
  //                     variant="standard"
  //                     type="text"
  //                     id="description"
  //                     name="description"
  //                     value={values.description}
  //                     label="Title"
  //                     focused
  //                     inputProps={{ readOnly: true }}
  //                   />
  //                 </FormControl>
  //                 <Stack
  //                   sx={{
  //                     //    width: {sm:'100%',md:'100%',lg:'100%'},
  //                     //gridColumn: "span 2",
  //                     alignContent: "center",
  //                     justifyContent: "center",
  //                     alignItems: "center",
  //                     position: "relative",
  //                     right: "0px",
  //                   }}
  //                 >
  //                   <Avatar
  //                     variant="rounded"
  //                     src={userimg}
  //                     sx={{ width: "200px", height: "120px" }}
  //                   />
  //                 </Stack>

  //                 <Box
  //                   m="5px 0 0 0"
  //                   //height={dataGridHeight}
  //                   height="50vh"
  //                   sx={{
  //                     "& .MuiDataGrid-root": {
  //                       border: "none",
  //                     },
  //                     "& .MuiDataGrid-cell": {
  //                       borderBottom: "none",
  //                     },
  //                     "& .name-column--cell": {
  //                       color: colors.greenAccent[300],
  //                     },
  //                     "& .MuiDataGrid-columnHeaders": {
  //                       backgroundColor: colors.blueAccent[800],
  //                       borderBottom: "none",
  //                     },
  //                     "& .MuiDataGrid-virtualScroller": {
  //                       backgroundColor: colors.primary[400],
  //                     },
  //                     "& .MuiDataGrid-footerContainer": {
  //                       borderTop: "none",
  //                       backgroundColor: colors.blueAccent[800],
  //                     },
  //                     "& .MuiCheckbox-root": {
  //                       color: `${colors.greenAccent[200]} !important`,
  //                     },
  //                     "& .odd-row": {
  //                       backgroundColor: "",
  //                       color: "", // Color for odd rows
  //                     },
  //                     "& .even-row": {
  //                       backgroundColor: "#D3D3D3",
  //                       color: "", // Color for even rows
  //                     },
  //                   }}
  //                 >
  //                   <DataGrid
  //                     sx={{
  //                       "& .MuiDataGrid-footerContainer": {
  //                         height: dataGridHeaderFooterHeight,
  //                         minHeight: dataGridHeaderFooterHeight,
  //                       },
  //                     }}
  //                     // rows={explorelistViewData}
  //                     // columns={newcolumn}
  //                     disableSelectionOnClick
  //                     getRowId={(row) => row.RecordID}
  //                     rowHeight={dataGridRowHeight}
  //                     headerHeight={dataGridHeaderFooterHeight}
  //                     // pageSize={pageSize}
  //                     // onPageSizeChange={(newPageSize) =>
  //                     //   setPageSize(newPageSize)
  //                     // }
  //                     onCellClick={(params) => {
  //                       // selectCellRowData({
  //                       //   rowData: params.row,
  //                       //   mode: "E",
  //                       //   field: params.field,
  //                       //   setFieldValue,
  //                       //   type: "product",
  //                       // });
  //                     }}
  //                     rowsPerPageOptions={[5, 10, 20]}
  //                     pagination
                     
  //                     // components={{
                       
  //                     //   Toolbar: Employee,
  //                     // }}
  //                     // onStateChange={(stateParams) =>
  //                     //   setRowCount(stateParams.pagination.rowCount)
  //                     // }
  //                     getRowClassName={(params) =>
  //                       params.indexRelativeToCurrentPage % 2 === 0
  //                         ? "odd-row"
  //                         : "even-row"
  //                     }
  //                     // loading={exploreLoading}
  //                     componentsProps={{
  //                       toolbar: {
  //                         showQuickFilter: true,
  //                         quickFilterProps: { debounceMs: 500 },
  //                       },
  //                     }}
  //                   />
  //                 </Box>

  //                 <FormControl sx={{ gap: formGap }}>
                   
  //                   {/* <CheckinAutocomplete
  //                     name="productItems"
  //                     //label="Item"
  //                     label={
  //                       <>
  //                         Item
  //                         <span style={{ color: "red", fontSize: "20px" }}>
  //                           *
  //                         </span>
  //                       </>
  //                     }
  //                     id="productItems"
  //                     value={values.productItems}
  //                     onChange={(newValue) => {
  //                       setFieldValue("productItems", {
  //                         RecordID: newValue.RecordID,
  //                         Code: newValue.Code,
  //                         Name: newValue.Name,
  //                       });
  //                       setFieldTouched("productItems", true);

  //                       setFieldValue(
  //                         "productCategoryID",
  //                         newValue.CrmItemCategoryID || ""
  //                       );
  //                       setFieldValue(
  //                         "productGroupID",
  //                         newValue.CrmItemGroupID || ""
  //                       );
  //                       // Auto-fill from dropdown
  //                       setFieldValue(
  //                         "productUnit",
  //                         newValue.ConsumptionUOM || ""
  //                       );
  //                       setFieldValue("productRate", newValue.Price || "");

  //                       // Recalculate amount
  //                       const qty = values.productQty || 1;
  //                       setFieldValue(
  //                         "productAmount",
  //                         (Number(newValue.Price) * Number(qty)).toFixed(2)
  //                       );

  //                       setTimeout(() => {
  //                         commentsRef.current?.focus();
  //                       }, 100);
  //                     }}
  //                     error={!!touched.productItems && !!errors.productItems}
  //                     helperText={touched.productItems && errors.productItems}
  //                     url={`${listViewurl}?data={"Query":{"AccessID":"2137","ScreenName":"Items","Filter":"CompanyID='${compID}' AND ItemsDesc ='Product'","Any":""}}`}
  //                   /> */}
                   
  //                   <TextField
  //                     fullWidth
  //                     variant="standard"
  //                     id="productUnit"
  //                     name="productUnit"
  //                     label="Unit"
                     
  //                     value={values.productUnit}
  //                     onBlur={handleBlur}
  //                     onChange={handleChange}
  //                     focused
  //                     error={!!touched.productUnit && !!errors.productUnit}
  //                     helperText={touched.productUnit && errors.productUnit}
  //                     InputProps={{
  //                       readOnly: true,
  //                     }}
  //                   />
                  
  //                   <TextField
  //                     fullWidth
  //                     variant="standard"
  //                     type="number"
  //                     value={values.productRate}
  //                     id="productRate"
  //                     name="productRate"
  //                     label="Rate"
                   
  //                     onBlur={handleBlur}
                     
  //                     onChange={(e) => {
  //                       const rate = e.target.value || 0;
  //                       setFieldValue("productRate", rate);

  //                       const qty = values.productQty || 0;
  //                       setFieldValue("productAmount", (qty * rate).toFixed(2));
  //                     }}
  //                     error={!!touched.productRate && !!errors.productRate}
  //                     helperText={touched.productRate && errors.productRate}
  //                     sx={{
  //                       backgroundColor: "#ffffff",
  //                       "& .MuiFilledInput-root": {
  //                         backgroundColor: "#ffffff",
  //                       },
  //                     }}
  //                     focused
  //                     inputProps={{ maxLength: 90 }}
  //                     InputProps={{
  //                       readOnly: true,
  //                       inputProps: { style: { textAlign: "right" } },
  //                     }}
  //                   />

                
  //                   <TextField
  //                     fullWidth
  //                     variant="standard"
  //                     type="number"
  //                     value={values.productQty}
  //                     id="productQty"
  //                     name="productQty"
  //                     label="Quantity"
                    
  //                     onBlur={handleBlur}
                     
  //                     onChange={(e) => {
  //                       const qty = e.target.value;
  //                       setFieldValue("productQty", qty);

  //                       const rate = values.productRate || 0;
  //                       setFieldValue("productAmount", (qty * rate).toFixed(2));
  //                     }}
  //                     error={!!touched.productQty && !!errors.productQty}
  //                     helperText={touched.productQty && errors.productQty}
  //                     sx={{
  //                       backgroundColor: "#ffffff",
  //                       "& .MuiFilledInput-root": {
  //                         backgroundColor: "#ffffff",
  //                       },
  //                     }}
  //                     focused
  //                     inputProps={{ maxLength: 90 }}
  //                     InputProps={{
  //                       inputProps: { style: { textAlign: "right" } },
  //                     }}
  //                   />

                  
  //                   <TextField
  //                     fullWidth
  //                     variant="standard"
  //                     type="number"
  //                     value={values.productAmount}
  //                     id="productAmount"
  //                     name="productAmount"
  //                     label="Amount"
  //                     onBlur={handleBlur}
  //                     InputProps={{
  //                       readOnly: true,
  //                       inputProps: { style: { textAlign: "right" } },
  //                     }}
  //                     sx={{
  //                       backgroundColor: "#ffffff",
  //                       "& .MuiFilledInput-root": {
  //                         backgroundColor: "#ffffff",
  //                       },
  //                     }}
  //                     focused
  //                   />

  //                   <TextField
  //                     fullWidth
  //                     variant="standard"
  //                     type="text"
  //                     value={values.productcomments}
  //                     id="productcomments"
  //                     name="productcomments"
  //                     // inputRef={commentsRef} // <-- ADD THIS
  //                     label="Comments"
  //                     onBlur={handleBlur}
  //                     onChange={handleChange}
  //                     // error={
  //                     //   !!touched.productcomments && !!errors.productcomments
  //                     // }
  //                     // helperText={
  //                     //   touched.productcomments && errors.productcomments
  //                     // }
  //                     sx={{
  //                       //gridColumn: "span 2",
  //                       backgroundColor: "#ffffff", // Set the background to white
  //                       "& .MuiFilledInput-root": {
  //                         backgroundColor: "#ffffff", // Ensure the filled variant also has a white background
  //                       },
  //                     }}
  //                     focused
  //                     autoFocus
  //                     multiline
  //                     inputProps={{ maxLength: 90 }}
  //                   />
  //                   {TaskSource === "Sprint" && (
  //                     <Box>
  //                       <Field
  //                         //  size="small"
  //                         type="checkbox"
  //                         name="productAdditionalBillable"
  //                         id="productAdditionalBillable"
  //                         onChange={handleChange}
  //                         onBlur={handleBlur}
  //                         as={Checkbox}
  //                         label="Additionally Billable"
  //                         sx={{
  //                           padding: "0px 5px 0px 0px",
  //                         }}
  //                       />
  //                       <FormLabel focused sx={{ color: "black !important" }}>
  //                         Additionally Billable
  //                       </FormLabel>
  //                     </Box>)}
  //                 </FormControl>
  //               </Box>
  //               <Box
  //                 display="flex"
  //                 justifyContent="end"
  //                 padding={1}
  //                 // style={{ marginTop: "-40px" }}
  //                 gap={2}
  //               >
  //                 {/* {YearFlag == "true" ? ( */}
  //                 <LoadingButton
  //                   color="secondary"
  //                   variant="contained"
  //                   type="submit"
  //                   loading={isLoading}
  //                   disabled={data.TaskSource === "Sprint" && data.Status === "AP"}
  //                 >
  //                   Save
  //                 </LoadingButton>
  //                 {/* ) : (
  //                           <Button
  //                             color="secondary"
  //                             variant="contained"
  //                             disabled={true}
  //                           >
  //                             Save
  //                           </Button>
  //                         )}
  //                         {YearFlag == "true" ? ( */}
  //                 <Button
  //                   color="error"
  //                   variant="contained"
  //                   onClick={() => {
  //                     Swal.fire({
  //                       title: errorMsgData.Warningmsg.Delete,
  //                       icon: "warning",
  //                       showCancelButton: true,
  //                       confirmButtonColor: "#3085d6",
  //                       cancelButtonColor: "#d33",
  //                       confirmButtonText: "Confirm",
  //                     }).then((result) => {
  //                       if (result.isConfirmed) {
  //                         // ProductSaveFn(values, resetForm, "harddelete");
  //                       } else {
  //                         return;
  //                       }
  //                     });
  //                   }}
  //                   //disabled={funMode === "A"}
  //                   disabled={funMode === "A" || (data.TaskSource === "Sprint" && data.Status === "AP")}

  //                 >
  //                   Delete
  //                 </Button>
  //                 {/* ) : (
  //                           <Button color="error" variant="contained" disabled={true}>
  //                             Delete
  //                           </Button>
  //                         )} */}
  //                 <Button
  //                   type="reset"
  //                   color="warning"
  //                   variant="contained"
  //                   onClick={() => {
  //                     setScreen(0);
  //                   }}
  //                 >
  //                   Cancel
  //                 </Button>
  //               </Box>
  //             </form>
  //           )}
  //         </Formik>
